import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const EcommerceFooter = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* NEWSLETTER */}
        <div className="newsletter">
          <div className="newsletter-wrapper">
            <div className="newsletter-text">
              <span className="footer-tag">Stay Updated</span>
              <h2>Subscribe to our newsletter</h2>
              <p>
                Get the latest updates on new products, exclusive offers, and
                trending collections.
              </p>
            </div>

            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                aria-label="Enter your email"
              />
              <button type="submit">
                <i className="fa-solid fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </div>

        {/* MAIN FOOTER */}
        <div className="footer-main">
          <div className="footer-grid">
            <div className="footer-column footer-brand">
              <h2 className="footer-logo">
                <span>Versa</span>core
              </h2>

              <p>
                Your one-stop shop for trendy products, home essentials,
                beauty, gadgets, and more for everyday living.
              </p>

              <div className="social-icons">
                <a href="/" aria-label="Facebook">
                  <i className="fa-brands fa-facebook-f"></i>
                </a>

                <a href="/" aria-label="Instagram">
                  <i className="fa-brands fa-instagram"></i>
                </a>

                <a href="/" aria-label="Twitter">
                  <i className="fa-brands fa-x-twitter"></i>
                </a>

                <a href="/" aria-label="YouTube">
                  <i className="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>

            <div className="footer-column">
              <h3>Shop</h3>
              <Link to="/shop">All Products</Link>
              <Link to="/new-arrivals">New Arrivals</Link>
              <Link to="/deals">Best Deals</Link>
              <Link to="/trending">Trending</Link>
            </div>

            <div className="footer-column">
              <h3>Customer Service</h3>
              <Link to="/trackorder">Track Order</Link>
              {/* <Link to="/">Returns & Refunds</Link> */}
              <Link to="/shippingPolicy">Shipping Policy</Link>
              {/* <Link to="/">FAQ</Link> */}
            </div>

            <div className="footer-column">
              <h3>Company</h3>
              {/* <Link to="/">About Us</Link> */}
              <Link to="/contact">Contact Us</Link>
              <Link to="/privacypolicy">Privacy Policy</Link>
              <Link to="/termscondition">Terms & Conditions</Link>
            </div>

            <div className="footer-column">
              <h3>We Accept</h3>
              <div className="payment-box">
                <span>VISA</span>
                <span>MasterCard</span>
                <span>UPI</span>
                <span>PayPal</span>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>© 2026 Versacore. All Rights Reserved.</p>

            <div className="footer-bottom-links">
              <Link to="/">Privacy</Link>
              <Link to="/">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default EcommerceFooter;